<template>
  <div class="profile_security">
    Here must be security logic
  </div>
</template>
<script>
export default {
  name: "ProfileSettings"
};
</script>
<style lang="scss"></style>
